<template>
  <compontent
    :is="facetsType"
    :type="topic"
    :name="name"
    :options="options"
    :device="device"

    :min-value="minValueRangeSlider"
    :max-value="maxValueRangeSlider"

    @selected="setFilter"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import FacetsTypeCheckbox from './types/checkbox.vue';
import FacetsTypeRadio from './types/radio.vue';
import FacetsTypeRange from './types/range.vue';
import FacetsTypeSearch from './types/search.vue';
import FacetsTypeSelect from './types/select.vue';

export default {
  name: 'FacetsItem',

  props: {
    /**
     * Which topic should be filterable<br />
     * The array could only contains more then 1 entry for the type search
     */
    topic: {
      type: Array,
      required: true,
    },

    /**
     * The type of facet
     */
    type: {
      type: String,
      required: true,
      validator: (value) => [
        'checkbox',
        'radio',
        'range',
        'search',
        'select',
      ].includes(value),
    },

    /**
     * The name that is shown as facet title
     */
    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    /**
     * What type of filtering should be used
     */
    filterType: {
      type: String,
      required: false,
      default: 'EXACT',
      validator: (value) => [
        'EXACT',
        'RANGE',
      ].includes(value),
    },

    /**
     * Filter option that you don't want in the list
     */
    blacklist: {
      type: Array,
      required: false,
      default: () => [],
    },

    sort: {
      type: String,
      required: false,
      default: 'asc',
      validator: (value) => ['asc', 'desc'].includes(value),
    },

    /**
     * Min value of the range slider
     */
    minValueRangeSlider: {
      type: Number,
      required: false,
    },

    /**
     * Max value of the range slider
     */
    maxValueRangeSlider: {
      type: Number,
      required: false,
    },

    device: {
      type: String,
      required: false,
    },
  },

  components: {
    FacetsTypeSelect,
    FacetsTypeCheckbox,
    FacetsTypeRadio,
    FacetsTypeRange,
    FacetsTypeSearch,
  },

  computed: {
    ...mapGetters({
      items: 'list/getItems',
    }),

    facetsType() {
      switch (this.type) {
        case 'checkbox':
          return 'FacetsTypeCheckbox';

        case 'range':
          return 'FacetsTypeRange';

        case 'search':
          return 'FacetsTypeSearch';

        case 'select':
          return 'FacetsTypeSelect';

        case 'radio':
          return 'FacetsTypeRadio';

        default:
          return null;
      }
    },

    options() {
      if (this.$slots.options) {
        return {
          [this.topic[0]]: JSON.parse(this.$slots.options[0].text),
        };
      }

      const array = {};

      this.topic.forEach((topic) => {
        array[topic] = [];
      });

      this.items.forEach((item) => {
        this.topic.forEach((topic) => {
          if (this.blacklist.includes(item[topic])) {
            return;
          }

          if (this.found(array[topic], item[topic])) {
            return;
          }

          let label = item[topic];

          if (this.$slots.map) {
            const mapping = JSON.parse(this.$slots.map[0].text);

            label = mapping[item[topic]];
          }

          array[topic].push({
            label,
            value: item[topic],
          });

          if (this.sort === 'asc') {
            array[topic].sort((a, b) => {
              const labelA = a.label.toUpperCase();
              const labelB = b.label.toUpperCase();

              if (labelA < labelB) {
                return -1;
              }

              if (labelA > labelB) {
                return 1;
              }

              return 0;
            });
          }

          if (this.sort === 'desc') {
            array[topic].sort((a, b) => {
              const labelA = a.label.toUpperCase();
              const labelB = b.label.toUpperCase();

              if (labelA > labelB) {
                return -1;
              }

              if (labelA < labelB) {
                return 1;
              }

              return 0;
            });
          }
        });
      });

      return array;
    },
  },

  methods: {
    found(some, value) {
      let isFound = false;

      some.forEach((option) => {
        if (option.value === value) {
          isFound = true;
        }
      });

      return isFound;
    },

    setFilter({
      value, key, label, initial,
    }) {
      this.$store.commit('filter/changed', {
        key,
        type: this.filterType,
        label,
        value,
      });
      this.$emit('filterChanged', { initial });
    },
  },
};
</script>
